// extracted by mini-css-extract-plugin
export default {"container":"Y9A9xO5HPX8bkJAjNLvS"};